//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
import DIC from '@/index/dictionary'

export default {
  components: {
    DialogDetailOrder: () => import('../DialogDetailOrder/index.vue'),
    DialogEditOrder: () => import('../DialogEditOrder/index.vue')
  },
  props: {
    tableData: {
      default: () => []
    },
    searchData: {
      default: () => ({})
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      detailDialogVisible: false,
      editDialogVisible: false,
      successDialogVisible: false,
      allSelect: false,
      isIndeterminate: false,
      rowData: {
        default: () => ({})
      },
      DIC: DIC,
      editDialogVisible: false
    }
  },
  watch: {
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    handleChangeAllSelect (val) {
      _.each(this.currentTableData, (t, i, l) => {
        if(_.has(t, 'selected')){
          t.selected = val
        }
      })
      this.isIndeterminate = false
    },
    handleChangeSelect (d) {
      let b = _.every(this.currentTableData, (item) => {
        return _.has(item, 'selected') ? item.selected : true;
      })
      this.allSelect = b
      this.isIndeterminate = !b;
    },
    handleTableRowClassName: function({row, rowIndex}) {
      if (row.isOrderItem === 1) {
        return 'el-table__row--bg el-table__row--mini';
      } else {
        return '';
      }
    },
    handleDeleteRow: function (row) {
      let data = {orderIds: row.orderId}
      this.$axios.post('/mtea/store/admin/order/del', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    },
    handleDeleteMultiRow: function (row) {
      let multipleSelection = _.filter(this.currentTableData, (item) => {
        return item.selected === true
      })
      let l = _.filter(multipleSelection, (item) => {
        return item.isOrderItem
      })
      if (l.length > 0) {
        let data = {orderIds: _.pluck(l, 'orderId').toString()}
        this.$axios.post('/mtea/store/admin/order/del', data).then(res => {
          this.$notify.success({
            title: '系统提示',
            message: '操作成功'
          })
          this.$emit('submit')
        }).finally(() => {
        })
      }
    },
    handleConfirmRow: function (row) {
      let data = {orderIds: row.orderId}
      this.$axios.post('/mtea/store/admin/order/confirm', data).then(res => {
        this.successDialogVisible = true
        this.$emit('submit')
      }).finally(() => {

      })
    },
    handleConfirmMultiRow: function (row) {
      let multipleSelection = _.filter(this.currentTableData, (item) => {
        return item.selected === true
      })
      let l = _.filter(multipleSelection, (item) => {
        return item.isOrderItem
      })
      if (l.length > 0) {
        let data = {orderIds: _.pluck(l, 'orderId').toString()}
        this.$axios.post('/mtea/store/admin/order/confirm', data).then(res => {
          this.successDialogVisible = true
          this.$emit('submit')
        }).finally(() => {

        })
      }
    }
  }
}
